import { render, staticRenderFns } from "./ClientCreateButton.vue?vue&type=template&id=3d2b85ff&scoped=true&"
import script from "./ClientCreateButton.vue?vue&type=script&lang=ts&"
export * from "./ClientCreateButton.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCreateButton.vue?vue&type=style&index=0&id=3d2b85ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b85ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
